import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './RedeemAwards.module.css';

import { Button } from '../../components/Button';
import { ButtonBack } from '../../components/ButtonBack';
import { HelmetComponent } from '../../components/Helmet';
import { Notify } from '../../components/Notify';
import { PointsRedeemed } from './components/PointsRedeemed';
import { PointsToRedeem } from './components/PointsToRedeem';
import { RescueCard } from './components/RescueCard';

import * as routes from '../../constants/Routes';
import { useAuth } from '../../hooks/useAuth';
import { useCart } from '../../hooks/useCart';
import { api } from '../../server/api';
import { IAwards } from './interfaces';
import { TotalPoints } from './components/TotalPoints';
import { useTransaction } from '../../hooks/useTransaction';
import { usePoints } from '../../hooks/usePoints';
import { PendingToRedeem } from './components/PendingToRedeem';
import { AlertModal } from '../../components/AlertModal';
import { GanheMaisCorretorView } from '../../features/ganhemaiscorretor-redeem/components/GanheMaisCorretorView';
import { GANHE_MAIS_CORRETOR_CLIENT_URL } from '../../constants/ClientUrls';

export function RedeemAwards() {
  const { client, player } = useAuth();
  const { getPoints } = usePoints();
  const { cart, addProductToCart } = useCart();
  const { lastTransaction, getLastTransaction } = useTransaction();
  const navigate = useNavigate();

  const [awards, setAwards] = useState<Array<IAwards>>([]);
  const [giftVouchers, setGiftVouchers] = useState<IAwards[]>([]);
  const [serviceAlertModalIsOpen, setServiceAlertModalIsOpen] = useState(false);

  useEffect(() => {
    getAwards();
    getLastTransaction('VOUCHER');
  }, []);

  useEffect(() => {
    if (player) {
      getAwards();
    }
    if (player && client && cart.length === 0) {
      getPoints(client.clientUrl, player.id);
    }
  }, [player, client]);

  const getAwards = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getNotGamifiedAwards',
        userType: 'player',
        seasonId: false,
        clientId: client.id,
        clientUrl: client.clientUrl,
        playerId: player?.id,
      };

      const { data } = await api.post(`/search`, parameters);

      if (data.success) {
        const awards = data.data.awards;

        setGiftVouchers(
          awards.filter(
            (award) =>
              award.premiumType.value === 'Físico' &&
              award.rescueType === 'conversion'
          )
        );
        setAwards(
          awards.filter(
            (award) =>
              award.premiumType.value !== 'Físico' ||
              (award.premiumType.value === 'Físico' &&
                award.rescueType !== 'conversion')
          )
        );
      } else {
        setAwards([]);
      }
    } catch (error) {
      console.log('getAwards error', error);
    }
  };

  const handleCart = () => {
    navigate(routes.CART);
  };

  const renderEmptyAward = () => {
    return (
      <>
        <div className="text-center my-3">
          <p className="m-0 fs-3 fw-semibold">Ops!...</p>
          <p className="m-0">Não há prêmios disponíveis!</p>
        </div>
      </>
    );
  };

  if (client?.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL) {
    return <GanheMaisCorretorView />;
  }

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Resgate de prêmios'}
      />

      {/* navegação */}
      <div className="py-3 fixed-navigation">
        <div className="row">
          <div className="col">
            <ButtonBack title="Premiações" />
          </div>
          <div className="col align-self-end">
            <div className="d-flex flex-row-reverse align-items-center">
              <Button
                icon="shopping_cart"
                text={`${cart.length} Finalizar carrinho`}
                color="primary"
                isLoading={false}
                onClick={handleCart}
              />
            </div>
          </div>
        </div>
      </div>
      {/* fim navegação */}

      {player && player.acceptedTerms && player.cpf && player.cpf !== '' && (
        <>
          <div className="row">
            <PointsToRedeem />
            {client?.settings?.redemptionPolicy && <PendingToRedeem />}
            <PointsRedeemed />
            <TotalPoints />
          </div>

          {lastTransaction?.balance > 0 &&
            giftVouchers?.map((giftVoucher, index) => (
              <div
                key={index}
                className={`${styles.voucherBanner}`}
                onClick={() => {
                  if (cart.length === 0) {
                    const result = addProductToCart(giftVoucher);
                    if (
                      typeof result === 'string' &&
                      result === 'Impossivel resgatar valores acima de 15000'
                    ) {
                      setServiceAlertModalIsOpen(true);
                    }
                  } else {
                    Notify(
                      'Para resgatar esse prêmio é necessário esvaziar o carrinho',
                      'warn'
                    );
                  }
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    alignItems: 'center',
                    fontSize: '25px',
                    textAlign: 'center',
                  }}
                >
                  VOCÊ GANHOU
                </div>
                <img
                  src={giftVoucher.premiumImage}
                  alt={giftVoucher.premiumName}
                  style={{
                    border: '5px solid #fff',
                    aspectRatio: '1/1',
                    maxHeight: '60%',
                    maxWidth: '60%',
                    padding: '0',
                    margin: '12px',
                  }}
                />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    fontSize: '12px',
                    textAlign: 'center',
                  }}
                >
                  <p
                    style={{
                      backgroundColor: '#fff',
                      color: `${client.primaryColor}`,
                      borderRadius: '10px',
                      fontWeight: 'bold',
                      maxWidth: 'fit-content',
                      padding: '5px',
                      fontSize: '25px',
                      margin: '5px',
                    }}
                  >
                    CLIQUE AQUI
                  </p>
                  para resgatar seu prêmio
                </div>
              </div>
            ))}

          {awards?.length > 0 && (
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="d-flex align-items-center">
                <i className="material-icons-outlined me-3 fs-5 color-text">
                  turned_in_not
                </i>
                <span className="fs-5">Prêmios disponíveis</span>
              </div>
              {client.settings?.statement?.enabled && (
                <>
                  <Link to={routes.STATEMENT}>
                    <Button text="Extrato" icon="subject" />
                  </Link>
                </>
              )}
            </div>
          )}

          <div className="row">
            {(!awards || awards.length === 0) && renderEmptyAward()}
            {awards &&
              awards.map(
                (award, index) =>
                  award.active && (
                    <div key={index} className="col-sm-12 col-md-6 col-xl-3">
                      <RescueCard award={award} />
                    </div>
                  )
              )}
          </div>
          {/* fim cards dos premios */}
        </>
      )}

      {player && !player.acceptedTerms && (
        <>
          <div className="p-3 text-center">
            <p className="fs-3">Cadastro incompleto</p>
            <p>
              Você precisa completar seu cadastro para poder visualizar/resgatar
              as premiações disponíveis no programa. Por favor, vá até seu
              perfil e complete.
            </p>
            <div className="d-flex justify-content-center">
              <Button
                text="Completar cadastro"
                color="primary"
                onClick={() => {
                  navigate(routes.EDIT_PROFILE);
                }}
              />
            </div>
          </div>
          <AlertModal
            modalIsOpen={serviceAlertModalIsOpen}
            toggleModal={() => setServiceAlertModalIsOpen(false)}
            title="OPS!"
            body="O limite diário de resgate é de R$ 15 mil. Mas não se preocupe: volte amanhã e resgate o valor restante."
          />
        </>
      )}
    </>
  );
}
